import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import {
  KeyboardArrowLeft,
} from '@material-ui/icons';
import {
  inject, observer,
} from 'mobx-react';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component,
} from 'react';
import {
  RouteComponentProps, withRouter,
} from 'react-router';
import * as Yup from 'yup';
import {
  FormField,
} from '../../components/GeneralCRUDComponent/FormFields/formFields';
import GeneralFormComponent from '../../components/GeneralCRUDComponent/GeneralFormComponent/GeneralFormComponent';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import Spinner from '../../components/Spinner';
import {
  countriesIsoCodes,
} from '../../constants/countries';
import {
  getDropdownLanguagesList, languageCodes,
} from '../../constants/languages';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  ICountry,
} from '../../mobx-store/storeInterfaces/authInterface';
import {
  IBannerAdsStore,
} from '../../mobx-store/storeInterfaces/bannerAdsInterface';
import {
  AuthStore,
} from '../../mobx-store/stores/authStore';
import {
  CountryStore,
} from '../../mobx-store/stores/countryStore';
import classes from './addEditAd.module.scss';

interface IProps extends WithSnackbarProps {
  bannerAdsStore: IBannerAdsStore;
  countryStore: CountryStore;
  authStore: AuthStore;
  match: any;
  history: any;
}

interface IState {
  formFields: FormField[];
  loading: boolean;
  loadingManagedCountries: boolean;
  processing: boolean;
  selectedLang: string;
}

enum adTypeValues {
  static = 'static',
  internal = 'internal',
  external = 'external',
}
export enum entityTypeValues {
  offers = 'offer',
  partners = 'partner',
  trophies = 'trophy',
  academies = 'academy',
  branches = 'branch',
  referral = 'referral',
  renewal = 'renewal',
  sports = 'sports',
}


@inject('bannerAdsStore')
@inject('countryStore')
@inject('authStore')
@observer
class AddEditAds extends Component<IProps & RouteComponentProps, IState> {
  isNew = false;

  isEgypt = false;

  isSports = false;

  isMarketing = false;

  isKenya = false;

  adId = -1;

  pageTitle = '';

  adsFormTitle = '';

  lastHistory = -1;

  adSchema: any;

  submitButton: any;

  cancelButton: any;

  adTypeSelectListValues = [
    {
      typeId: 'static',
      typeTitle: 'Static',
    },
    {
      typeId: 'internal',
      typeTitle: 'Internal',
    },
    {
      typeId: 'external',
      typeTitle: 'External',
    },
  ];

  commonEntityTpes = [
    {
      typeId: 'offer',
      typeTitle: 'Offers',
    },
    {
      typeId: 'partner',
      typeTitle: 'Partners',
    },
    {
      typeId: 'trophy',
      typeTitle: 'Trophies',
    },
    {
      typeId: 'academy',
      typeTitle: 'Academy',
    },
    {
      typeId: 'branch',
      typeTitle: 'Branch',
    },
    {
      typeId: 'referral',
      typeTitle: 'Referral',
    },
    {
      typeId: 'renewal',
      typeTitle: 'Renewal',
    },
  ];

  entityTypeSelectListValues = [
    ...this.commonEntityTpes,
    {
      typeId: entityTypeValues.sports,
      typeTitle: entityTypeValues.sports,
    },
  ];

  entityMarktingTypeSelectListValues = this.commonEntityTpes;

  entityTypeSportsSelectListValues = [
    {
      typeId: entityTypeValues.sports,
      typeTitle: entityTypeValues.sports,
    },
  ];

  entityTypeKenyaSelectListValues = [
    {
      typeId: 'academy',
      typeTitle: 'Academy',
    },
    {
      typeId: 'branch',
      typeTitle: 'Branch',
    },
    {
      typeId: entityTypeValues.sports,
      typeTitle: entityTypeValues.sports,
    },
  ];

  dropdownLanguages: {
    langList: {langCode: string; langValue: string} [];
    selectedLang: string;
    label: string;
    onChange(langCode: string): any;
  } | null = null;

  staticFormFields: FormField[] = [];

  setStaticFormFields = (): void => {
    this.staticFormFields = [
      {
        name: 'title',
        label: this.isNew && this.isEgypt ? translate('editAdTitleArabic', {
        }) : translate('editAdTitle', {
        }),
        type: 'text',
        filedType: 'InputField',
      },
      {
        name: 'adTypeList',
        label: translate('bannerAdsTypeListFieldTitle', {
        }),
        selectList: this.adTypeSelectListValues,
        selectListValue: 'typeTitle',
        selectListKey: 'typeId',
        filedType: 'DropdownField',
        value: 0,
      },
      {
        name: 'backgroundImage',
        label: translate('addAdPageFormImage', {
        }),
        filedType: 'GalleryField',
        isLimitToOneImage: true,
        accept: 'image/*',
        size: 200,
      },
      {
        name: 'isPublished',
        label: translate('addArticlePageFormStatus', {
        }),
        filedType: 'ToggleButtonField',
        activeLabel: translate('addArticlePageFormStatusPublishedLabel', {
        }),
        inactiveLabel: translate('addArticlePageFormStatusUnpublishedLabel', {
        }),
        value: true,
      },
      {
        name: 'autoScheduled',
        label: translate('addArticlePageFormEndDate', {
        }),
        filedType: 'AutoScheduledField',
        toggle: {
          name: 'toggle',
          label: translate('addArticlePageFormAutoScheduled', {
          }),
          filedType: 'ToggleButtonField',
          activeLabel: translate('addArticlePageFormAutoScheduledOffLabel', {
          }),
          inactiveLabel: translate('addArticlePageFormAutoScheduledOnLabel', {
          }),
        },
        startDate: {
          name: 'startDate',
          label: translate('addArticlePageFormStartDate', {
          }),
          filedType: 'DatePickerField',
          minDate: new Date(),
        },
        endDate: {
          name: 'endDate',
          label: translate('addArticlePageFormEndDate', {
          }),
          filedType: 'DatePickerField',
          minDate: new Date(),
        },
      },
    ];
  };

  internalLinkFormFields: FormField[] = [];

  setInternalLinkFormFields = (): void => {
    this.internalLinkFormFields = [
      {
        name: 'title',
        label: this.isNew && this.isEgypt ? translate('editAdTitleArabic', {
        }) : translate('editAdTitle', {
        }),
        type: 'text',
        filedType: 'InputField',
      },
      {
        name: 'adTypeList',
        label: translate('bannerAdsTypeListFieldTitle', {
        }),
        selectList: this.adTypeSelectListValues,
        selectListValue: 'typeTitle',
        selectListKey: 'typeId',
        filedType: 'DropdownField',
        value: 1,
      },
      {
        name: 'entityTypeList',
        label: translate('bannerAdsEntityTypeListFieldTitle', {
        }),
        selectList: this.isSports ? this.entityTypeSportsSelectListValues : (this.isMarketing ? this.entityMarktingTypeSelectListValues : (this.isKenya ? this.entityTypeKenyaSelectListValues : this.entityTypeSelectListValues)),
        selectListValue: 'typeTitle',
        selectListKey: 'typeId',
        filedType: 'DropdownField',
        value: 1,
      },
      {
        name: 'entityContentList',
        label: translate('bannerAdsEntityContentListFieldTitle', {
        }),
        selectList: this.props.bannerAdsStore.entityList.slice(0),
        selectListValue: 'title',
        selectListKey: 'id',
        filedType: 'DropdownField',
        value: 1,
      },
      {
        name: 'backgroundImage',
        label: translate('addAdPageFormImage', {
        }),
        filedType: 'GalleryField',
        isLimitToOneImage: true,
        accept: 'image/*',
        size: 200,
      },
      {
        name: 'isPublished',
        label: translate('addArticlePageFormStatus', {
        }),
        filedType: 'ToggleButtonField',
        activeLabel: translate('addArticlePageFormStatusPublishedLabel', {
        }),
        inactiveLabel: translate('addArticlePageFormStatusUnpublishedLabel', {
        }),
        value: true,
      },
      {
        name: 'autoScheduled',
        label: translate('addArticlePageFormEndDate', {
        }),
        filedType: 'AutoScheduledField',
        toggle: {
          name: 'toggle',
          label: translate('addArticlePageFormAutoScheduled', {
          }),
          filedType: 'ToggleButtonField',
          activeLabel: translate('addArticlePageFormAutoScheduledOffLabel', {
          }),
          inactiveLabel: translate('addArticlePageFormAutoScheduledOnLabel', {
          }),
        },
        startDate: {
          name: 'startDate',
          label: translate('addArticlePageFormStartDate', {
          }),
          filedType: 'DatePickerField',
          minDate: new Date(),
        },
        endDate: {
          name: 'endDate',
          label: translate('addArticlePageFormEndDate', {
          }),
          filedType: 'DatePickerField',
          minDate: new Date(),
        },
      },
    ];
  };

  externalLinkFormFields: FormField[] = [];

  setExternalLinkFormFields = (): void => {
    this.externalLinkFormFields = [
      {
        name: 'title',
        label: this.isNew && this.isEgypt ? translate('editAdTitleArabic', {
        }) : translate('editAdTitle', {
        }),
        type: 'text',
        filedType: 'InputField',
      },
      {
        name: 'adTypeList',
        label: translate('bannerAdsTypeListFieldTitle', {
        }),
        selectList: this.adTypeSelectListValues,
        selectListValue: 'typeTitle',
        selectListKey: 'typeId',
        filedType: 'DropdownField',
        value: 2,
      },
      {
        name: 'externalLink',
        label: translate('editAdLink', {
        }),
        type: 'text',
        filedType: 'InputField',
      },
      {
        name: 'backgroundImage',
        label: translate('addAdPageFormImage', {
        }),
        filedType: 'GalleryField',
        isLimitToOneImage: true,
        accept: 'image/*',
        size: 200,
      },
      {
        name: 'isPublished',
        label: translate('addArticlePageFormStatus', {
        }),
        filedType: 'ToggleButtonField',
        activeLabel: translate('addArticlePageFormStatusPublishedLabel', {
        }),
        inactiveLabel: translate('addArticlePageFormStatusUnpublishedLabel', {
        }),
        value: true,
      },
      {
        name: 'autoScheduled',
        label: translate('addArticlePageFormEndDate', {
        }),
        filedType: 'AutoScheduledField',
        toggle: {
          name: 'toggle',
          label: translate('addArticlePageFormAutoScheduled', {
          }),
          filedType: 'ToggleButtonField',
          activeLabel: translate('addArticlePageFormAutoScheduledOffLabel', {
          }),
          inactiveLabel: translate('addArticlePageFormAutoScheduledOnLabel', {
          }),
        },
        startDate: {
          name: 'startDate',
          label: translate('addArticlePageFormStartDate', {
          }),
          filedType: 'DatePickerField',
          minDate: new Date(),
        },
        endDate: {
          name: 'endDate',
          label: translate('addArticlePageFormEndDate', {
          }),
          filedType: 'DatePickerField',
          minDate: new Date(),
        },
      },
    ];
  };

  constructor(props: IProps & RouteComponentProps) {
    super(props);
    this.initializeComponent(props);
  }

  initializeComponent(props: IProps & RouteComponentProps, isConstructor = true) {
    if (props.match.params.id) {
      this.isNew = false;
      this.adId = props.match.params.id;
      this.pageTitle = translate('editAdsPageTitle', {
      });
    } else {
      this.isNew = true;
      this.pageTitle = translate('addAdsPageTitle', {
      });
    }
    this.initCategorySchema();
    this.initState(isConstructor);
    this.submitButton = this.getSubmitButton();
    this.cancelButton = this.getCancelButton();
    this.adsFormTitle = translate('adsFormTitle', {
    });
    this.dropdownLanguages = this.getDropdownLanguages();
  }

  handelLanguageChange = (langCode: string) => {
    if (this.isNew) {
      this.setState({
        selectedLang: langCode,
      });
    } else {
      this.getAd(langCode);
    }
  };

  async componentWillReceiveProps(nextProps: IProps & RouteComponentProps) {
    if (this.props.location.pathname !== nextProps.location.pathname) {
      this.lastHistory = -2;
      this.setInternalLinkFormFields();
      this.setStaticFormFields();
      this.setExternalLinkFormFields();
      this.updateStateWithAdData();
      this.initializeComponent(nextProps, false);
      this.setState({
        loadingManagedCountries: false,
      });
      this.forceUpdate();
      if (!this.isNew) {
        this.props.bannerAdsStore.getAdById(this.adId, this.state.selectedLang)
          .then(() => {
            this.updateStateWithAdData();
          }).catch(() => {
            this.setState({
              loading: false,
            });
          });
      }
    }
  }

  getDropdownLanguages = () => {
    if (this.isNew) {
      return null;
    }
    return {
      langList: getDropdownLanguagesList(),
      selectedLang: this.state.selectedLang,
      label: 'Select Languages',
      onChange: this.handelLanguageChange,
    };
  };

  initCategorySchema = () => {
    this.adSchema = Yup.object().shape({
      title: Yup.string()
        .required('Required'),
      externalLink: Yup.string(),
      backgroundImage: Yup.array()
        .required('Required'),
      autoScheduled: Yup.object().shape({
        toggle: Yup.boolean()
          .required('Required'),
        startDate: Yup.date()
          .nullable(true)
          .when('toggle', {
            is: true,
            then: Yup.date().typeError('Invalid date').required('Required'),
          }),
        endDate: Yup.date().nullable(true),
      }),
      isPublished: Yup.boolean().default(true),
    });
  };

  initState = (isConstructor = true) => {
    const initState: IState = {
      loadingManagedCountries: true,
      processing: false,
      loading: !this.isNew,
      selectedLang: languageCodes.english,
      formFields: this.staticFormFields,
    };
    if (isConstructor) {
      this.state = initState;
    } else {
      this.setState(initState);
    }
  };

  handleSubmit = (values: any): void => {
    const {
      countryStore,
    } = this.props;
    values.availableCountries = countryStore.managedCountries.map((country: ICountry) => country.isoCode);
    if (this.isSports) {
      values.entityTypeList = 'sports';
    }
    this.setState({
      processing: true,
    });
    if (this.isNew) {
      this.props.bannerAdsStore.createAd(values)
        .then((bannerId) => {
          if (this.isEgypt) {
            this.props.history.push(`${bannerId}/edit`);
          } else {
            this.props.history.go(this.lastHistory);
          }
        }).catch((error) => {
          this.setState({
            processing: false,
          });
          SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
          }), 5000, 'error');
        });
    } else {
      this.props.bannerAdsStore.updateAd(values, this.adId, this.state.selectedLang)
        .then(() => {
          this.setState({
            processing: false,
          });
          SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
          }), 5000, 'success');
          this.props.history.go(this.lastHistory);
        }).catch((error) => {
          this.setState({
            processing: false,
          });
          SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
          }), 5000, 'error');
        });
    }
  };

  handleCancel = (): void => {
    this.props.history.goBack();
  };

  getSubmitButton = () => ({
    title: (this.isNew && this.isEgypt ? 'To Next Language' : 'Save Changes'),
    onSubmit: this.handleSubmit,
  });

  getCancelButton = () => ({
    title: 'Cancel',
    onCancel: this.handleCancel,
  });

  updateStateWithAdData = async () => {
    const {
      bannerAdsStore, countryStore,
    } = this.props;
    const formFieldsWithData = [];

    if (bannerAdsStore.selectedAd.adTypeList === adTypeValues.static) {
      this.setState({
        formFields: this.staticFormFields,
      });
    } else if (bannerAdsStore.selectedAd.adTypeList === adTypeValues.internal) {
      this.setState({
        formFields: this.internalLinkFormFields,
      });
      if (bannerAdsStore.selectedAd.entityTypeList === entityTypeValues.partners) {
        await bannerAdsStore.getDeglawyPartners(this.state.selectedLang);
      } else if (bannerAdsStore.selectedAd.entityTypeList === entityTypeValues.offers) {
        await bannerAdsStore.getDeglawyOffers(this.state.selectedLang);
      } else if (bannerAdsStore.selectedAd.entityTypeList === entityTypeValues.trophies) {
        await bannerAdsStore.getDeglawyTrophies(this.state.selectedLang);
      } else if (bannerAdsStore.selectedAd.entityTypeList === entityTypeValues.academies) {
        await bannerAdsStore.getAcademies(countryStore.managedCountries, this.state.selectedLang);
      } else if (bannerAdsStore.selectedAd.entityTypeList === entityTypeValues.branches) {
        await bannerAdsStore.getBranches(countryStore.managedCountries, this.state.selectedLang);
      }
    } else if (bannerAdsStore.selectedAd.adTypeList === adTypeValues.external) {
      this.setState({
        formFields: this.externalLinkFormFields,
      });
    }

    for (const field of this.state.formFields) {
      if (field.name === 'entityContentList') {
        // don't add entity content list to referral ad
        if (this.props.bannerAdsStore.selectedAd.entityTypeList === entityTypeValues.referral
             || this.props.bannerAdsStore.selectedAd.entityTypeList === entityTypeValues.renewal
             || this.props.bannerAdsStore.selectedAd.entityTypeList === entityTypeValues.sports) {
          continue;
        }
        formFieldsWithData.push({
          ...field,
          selectList: this.props.bannerAdsStore.entityList,
          value: this.props.bannerAdsStore.selectedAd[field.name],
        });
      } else {
        formFieldsWithData.push({
          ...field, value: this.props.bannerAdsStore.selectedAd[field.name],
        });
      }
    }
    this.setState({
      formFields: formFieldsWithData, loading: false,
    });
  };

  getFormPageHeader = () => (
    <div className={classes.header}>
      <IconButton
        className={classes.backButton}
        onClick={() => this.props.history.goBack()}
        aria-label="Back"
      >
        <KeyboardArrowLeft />
      </IconButton>
      <Typography className={classes.title} variant="h6" gutterBottom>
        {this.pageTitle}
      </Typography>
    </div>
  );

  render() {
    return (
      <div className={classes.container}>
        {this.getFormPageHeader()}
        <div className={classes.content}>
          {this.state.loading || this.state.loadingManagedCountries
            ? <Spinner />
            : (
              <GeneralFormComponent
                dropdownLanguages={this.isEgypt ? this.dropdownLanguages : null}
                formTitle={this.adsFormTitle}
                fields={this.state.formFields}
                formSchema={this.adSchema}
                submitButton={this.submitButton}
                cancelButton={this.cancelButton}
                processing={this.state.processing}
                onChangeValues={(key: any, value: any) => this.onChangeValues(key, value)}
              />
            )}
        </div>
      </div>
    );
  }

  onChangeValues = async (key: any, value: any) => {
    const {
      bannerAdsStore, countryStore,
    } = this.props;

    if (key === 'adTypeList') {
      if (value === adTypeValues.static) {
        this.setState({
          formFields: this.staticFormFields,
        });
      }
      if (value === adTypeValues.internal) {
        this.setState({
          formFields: this.internalLinkFormFields,
        });
      }
      if (value === adTypeValues.external) {
        this.setState({
          formFields: this.externalLinkFormFields,
        });
      }
    } else if (key === 'entityTypeList') {
      if (value === entityTypeValues.offers) {
        await bannerAdsStore.getDeglawyOffers(languageCodes.english);
      }
      if (value === entityTypeValues.partners) {
        await bannerAdsStore.getDeglawyPartners(languageCodes.english);
      }
      if (value === entityTypeValues.trophies) {
        await bannerAdsStore.getDeglawyTrophies(languageCodes.english);
      }
      if (value === entityTypeValues.academies) {
        await bannerAdsStore.getAcademies(countryStore.managedCountries, languageCodes.english);
      }
      if (value === entityTypeValues.branches) {
        await bannerAdsStore.getBranches(countryStore.managedCountries, languageCodes.english);
      }

      // add entity content list in case of any internal field selected
      this.internalLinkFormFields = [
        ...this.internalLinkFormFields.slice(0, 3),
        {
          ...this.internalLinkFormFields[3],
          selectList: bannerAdsStore.entityList,
        },
        ...this.internalLinkFormFields.slice(4),
      ];

      // remove entity content list in case of referral
      if (value === entityTypeValues.referral
           || value === entityTypeValues.renewal
           || value === entityTypeValues.sports) {
        let referralFormFields = [];
        referralFormFields = [
          ...this.internalLinkFormFields.slice(0, 3),
          ...this.internalLinkFormFields.slice(4),
        ];
        this.setState({
          formFields: referralFormFields,
        });
        return;
      }

      this.setState({
        formFields: this.internalLinkFormFields,
      });
    }
  };

  async componentDidMount() {
    const {
      countryStore, bannerAdsStore, authStore,
    } = this.props;
    const {
      userData,
    } = authStore;
    const {
      title,
    } = userData.role;
    this.isSports = title === 'sports';
    this.isMarketing = title === 'marketing';
    this.isKenya = title === 'ADMIN_KENYA';

    await countryStore.getUserManagedCountries();
    if (countryStore.managedCountries.some((country: ICountry) => country.isoCode === countriesIsoCodes.egypt)) {
      this.isEgypt = true;
    }
    this.submitButton = this.getSubmitButton();
    this.updateStateWithAdData();
    this.setInternalLinkFormFields();
    this.setStaticFormFields();
    this.setExternalLinkFormFields();
    this.initState(false);
    this.setState({
      loadingManagedCountries: false,
    });
    if (!this.isNew) {
      bannerAdsStore.getAdById(this.adId, this.state.selectedLang)
        .then(() => {
          this.updateStateWithAdData();
        }).catch(() => {
          this.setState({
            loading: false,
          });
        });
    }
  }

  getAd = (langCode: string) => {
    this.setState({
      loading: true,
    });
    this.props.bannerAdsStore.getAdById(this.adId, langCode)
      .then(() => {
        this.updateStateWithAdData();
        this.dropdownLanguages!.selectedLang = langCode;
        this.setState({
          selectedLang: langCode,
        });
      }).catch(() => {
        this.setState({
          loading: false,
        });
      });
  };
}
export default withRouter(AddEditAds);
